import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return{
            id: null,
            title: '',
            content: '',
            category: '',
            files: [],
            country: 1,
            status: '',

            answerId: null,
            answerTitle: '',
            answerContent: '',
        }
    },
    validators: {
        id: function (value) {
            return Validator.value(value)
        },
        title: function (value) {
          return Validator.value(value)
              .required('제목을 입력해주세요.')
        },
        category: function (value) {
          return Validator.value(value)
              .required('카테고리를 선택해주세요.');
        },
        content: function (value) {
          return Validator.value(value)
              .required('내용을 입력해주세요.')
              .custom(
                  () => {
                      let content = value.replace(/<(\/p|br|p)([^>]*)>/gi,"");
                      if(content.length === 0) {
                          return '내용을 입력해주세요.'
                      }
                  }
              )
        },
        country: function (value) {
            return Validator.value(value)
                .required('나라를 선택해주세요.');
        },
        answerId: function (value) {
            return Validator.value(value)
        },
        answerTitle: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.')
        },
        answerContent: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
        },
        status: function (value) {
            return Validator.value(value)
                .required('상태을 선택해주세요.')
        },
    },
    watch: {},
}